// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1lxZe","header":"MergedInvoice_header__1vTPY"};